export default "__VITE_ASSET__9b4a6cdd__"